export default {
  LEARN_MORE: '997d61fc-1963-46dd-8875-8f51facd4aaa',
};
